var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlaneSend = function SvgPlaneSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m145.06 870.42 744.53-319.15c34.56-14.93 34.56-63.57 0-78.51L145.06 153.62c-28.16-12.37-59.31 8.53-59.31 38.83l-.43 196.69c0 21.33 15.79 39.68 37.12 42.24l602.88 80.64-602.87 80.21c-21.33 2.99-37.12 21.33-37.12 42.67l.43 196.69c0 30.29 31.15 51.2 59.31 38.83Z"
  })));
};
export default SvgPlaneSend;